import { Injectable } from '@angular/core';
import { interval, Subscription, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private tokenCheckInterval = 1000 * 60;
  private tokenRefreshThreshold = environment.tokenRefreshThreshold;
  private timerSubscription: Subscription | null = null;

  constructor(private authService: AuthService) {}

  startTokenRefreshTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }

    this.timerSubscription = interval(this.tokenCheckInterval)
      .pipe(
        switchMap(() => {
          const expirationTime = this.authService.getTokenExpirationTime();
          const currentTime = new Date().getTime();
          const timeRemaining = expirationTime - currentTime;

          if (timeRemaining <= this.tokenRefreshThreshold && timeRemaining > 0) {
            return this.authService.refreshAccessToken().pipe(
              tap(() => console.log('Token refreshed successfully.')),
              catchError((error) => {
                console.error('Token refresh failed:', error);
                this.authService.logout();
                return of(null);
              })
            );
          }

          if (timeRemaining <= 0) {
            console.warn('Access token expired. Logging out...');
            this.authService.logout();
            return of(null);
          }

          return of(null);
        }),
        catchError((error) => {
          console.error('Unexpected error in token refresh timer:', error);
          return of(null);
        })
      )
      .subscribe({
        next: () => {
          console.log('Token refresh check completed.');
        },
        error: (error) => {
          console.error('Subscription error:', error);
        },
        complete: () => {
          console.log('Token refresh timer stopped unexpectedly.');
        },
      });
  }

  stopTokenRefreshTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }


  isTokenExpire(){
    const expirationTime = this.authService.getTokenExpirationTime();
    const currentTime = new Date().getTime();
    const timeRemaining = expirationTime - currentTime;
    if (timeRemaining <= 0) {
      console.warn('Access token expired. Logging out...');
      this.authService.logout(true);
    }
  }
}
